import { defineMessages } from 'react-intl';

export const scope = 'app.components.UnassignedPlayersMessage';

export const messages = defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Not every {athlete} can be assigned yet. Every active {athlete} needs a group and {aSession} in every stage (or one from each day of split stages):',
  },
  ungrouped: {
    id: `${scope}.ungrouped`,
    defaultMessage: '{count} {athletesPlay} {position}, which none of this grouping\'s position limits include, so they aren\'t placed in any group. Add {position} to a position limit.',
  },
  noPosition: {
    id: `${scope}.noPosition`,
    defaultMessage: '{count} {athletesHave} no position, so they aren\'t placed in any group. Set their position.',
  },
  unknownPosition: {
    id: `${scope}.unknownPosition`,
    defaultMessage: '{count} {athletesHave} a position that\'s no longer in use, so they aren\'t placed in any group. Update their position.',
  },
  shortRun: {
    id: `${scope}.shortRun`,
    defaultMessage: '{dayPrefix}{stages} {make} room for {tracks} of the {groupCount} groups, so {unseatedGroups} {groupsGet} no {session} there.',
  },
  dayPrefix: {
    id: `${scope}.dayPrefix`,
    defaultMessage: 'Day {day}: ',
  },
  fixesHeading: {
    id: `${scope}.fixesHeading`,
    defaultMessage: 'To fix the missing {sessions}, update your {formatLink}:',
  },
  formatLink: {
    id: `${scope}.formatLink`,
    defaultMessage: 'format',
  },
  raiseSessionLimits: {
    id: `${scope}.raiseSessionLimits`,
    defaultMessage: 'Raise the {session} limits on {stages} so they make room for all {groupCount} groups',
  },
  raisePlayerLimits: {
    id: `${scope}.raisePlayerLimits`,
    defaultMessage: 'Or raise the {athlete} limits per {session} so the grouping forms {groupCount} {groups}: {changes}',
  },
  change: {
    id: `${scope}.change`,
    defaultMessage: '{name} from {from} to {to}',
  },
});
